import { makeCustomerUpdateRequestsRepository } from 'modules/customer/infra/repositories';

import { FetchUpdateDataRequestUseCase } from './implementations/FetchUpdateDataRequestUseCase';

let instance: FetchUpdateDataRequestUseCase | null = null;

export default function makeFetchUpdateDataRequestUseCase() {
  if (!instance) {
    const repository = makeCustomerUpdateRequestsRepository();

    instance = new FetchUpdateDataRequestUseCase(repository);
  }

  return instance;
}
